/* eslint-disable sort-keys */
import { CFTokens } from '../../../tokens';
export const FONT_SIZE = {
    xs: 11,
    sm: 13,
    md: 14,
    lg: 16,
    xl: 18,
};
export const ROOT_BACKGROUND = {
    FOCUSED: CFTokens.COLOR.INTERACTIVE_HOVER_SECONDARY,
};
export const ROOT_BORDER_COLOR = {
    DEFAULT: CFTokens.COLOR.BORDER_DEFAULT,
    FOCUSED: CFTokens.COLOR.BORDER_STRONG,
};
export const ROOT_HEIGHT = {
    xs: 24,
    sm: 32,
    md: 40,
    lg: 48,
    xl: 56,
};
